import { render, staticRenderFns } from "./QrCodeForm.vue?vue&type=template&id=747c86d7&"
import script from "./QrCodeForm.vue?vue&type=script&lang=ts&"
export * from "./QrCodeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports